module.exports = __webpack_public_path__ + "img/f_c_sc_1.6094556e.png";